import React, { useState, useEffect, useContext } from 'react';
import { Box, TextField, Button, Typography, Chip, Stack, IconButton, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit'; // Import EditIcon
import { CanvasContext } from "../contexts/CanvasContext";
import '../styles/prompt-dock.css';

const PromptDock = ({ isVisible, onClose, onGenerateEdit, isManuallyOpened }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const { selectedSegments, setSelectedSegments, enrichedSelectedSegments, layers } = useContext(CanvasContext);
    const [textFieldValue, setTextFieldValue] = useState('');

    useEffect(() => {
        // Auto-collapse if selection drops below 2 and dock is visible, AND it wasn't manually opened
        if (isVisible && selectedSegments.length < 2 && !isManuallyOpened) {
            onClose();
        }
    }, [selectedSegments, isVisible, onClose, isManuallyOpened]);

    const handleChipClick = (segmentToRemove) => {
        setSelectedSegments((prevSelectedSegments) => {
            const newSelectedSegments = prevSelectedSegments.filter(
                (s) => s.animation_event !== segmentToRemove.animation_event
            );
            return newSelectedSegments;
        });
    };

    const handleGenerateClick = () => {
        onGenerateEdit(textFieldValue);
        setTextFieldValue(''); // Clear text field after generating
    };

    const getColorByRole = (role) => {
        const roleActiveColors = {
            primary: '#00A9E0',
            secondary: '#92C911',
            text: '#E87722',
            background: '#CE0F69',
        };
        return roleActiveColors[role.toLowerCase()] || '#007bff';
    };

    if (!isVisible) {
        return null;
    }

    return (
        <Box className="prompt-dock-overlay">
            <Box className="prompt-dock-box">
                <Stack direction="row" alignItems="center" sx={{ width: '100%' }}>
                    {/* <Box className="context-label anchored" sx={{ flexShrink: 0 }}>
                        {selectedSegments.length > 1 && (
                            <Box sx={{
                                display: 'flex',
                                marginRight: '8px',
                                height: '16px'
                            }}>
                                {[...new Set(selectedSegments.map(s => s.target_type.toLowerCase()))].map((type, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: '8px',
                                            height: '100%',
                                            backgroundColor: getColorByRole(type, true),
                                            marginRight: '2px'
                                        }}
                                    />
                                ))}
                            </Box>
                        )}
                        <Typography variant="caption" className="context-label-text">
                            Anchored Prompt
                        </Typography>
                    </Box> */}

                    <Box className="tag-chips-container" sx={{ display: 'flex', flexWrap: 'wrap'}}>
                        <Stack direction="row">
                            {enrichedSelectedSegments.map((segment) => {
                                // Find the first matching layer for any of the segment's targets
                                let avatarSrc = null;
                                if (segment.targets && Array.isArray(segment.targets)) {
                                    console.log(layers);
                                    for (const target of segment.targets) {
                                        console.log('Target:', target);

                                        let targetId;
                                        if (typeof target === 'string') {
                                            targetId = target.startsWith('#') ? target.substring(1) : target;
                                        } else {
                                            targetId = target.id;
                                        }
                                        const matchingLayer = layers.find(layer => layer.id === targetId);
                                        if (matchingLayer && matchingLayer.src) {
                                            avatarSrc = matchingLayer.src;
                                            break;
                                        }
                                    }
                                }
                                return (
                                    <Chip
                                        key={segment.animation_event}
                                        label={segment.altTexts.join(', ')}
                                        onDelete={() => handleChipClick(segment)}
                                        sx={{
                                            backgroundColor: getColorByRole(segment.target_type),
                                            color: 'white',
                                            display: 'flex', // Make the chip a flex container
                                            flexDirection: 'row', // Arrange items in a row
                                            alignItems: 'center', // Center items vertically
                                            maxWidth: 180,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            '& .MuiChip-label': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                maxWidth: 120,
                                                display: 'block',
                                            },
                                            '& .MuiChip-deleteIcon': {
                                                color: 'rgba(255,255,255,0.7)',
                                            },
                                            '& .MuiChip-deleteIcon:hover': {
                                                color: 'white',
                                            },
                                        }}
                                        size="small"
                                        avatar={avatarSrc ? <img src={avatarSrc} alt={segment.altTexts.join(', ')} style={{ height: 24, width: 24, borderRadius: '50%', objectFit: 'cover', marginLeft: 4 }} /> : null}
                                    />
                                );
                            })}

                        </Stack>
                        
                    </Box>

                    <IconButton size="small" onClick={onClose} sx={{ flexShrink: 0 }}>
                        <CloseIcon />
                    </IconButton>
                </Stack>

                <Stack direction="row" spacing={1} sx={{ mt: 2, width: '100%' }}>

                    <TextField
                    value={textFieldValue}
                    placeholder={'Customize animation with prompt'}
                    onChange={(e) => setTextFieldValue(e.target.value)}
                    className="prompt-textfield"
                    size={isMobile ? "small" : "medium"}
                    fullWidth
                    sx={{ mt: 1 }}
                />

                <IconButton
                    color="secondary"
                    onClick={handleGenerateClick}
                    sx={{ mt: 1, alignSelf: 'flex-end' }}
                >
                    <EditIcon />
                </IconButton>
                    
                </Stack>

                
            </Box>
        </Box>
    );
};

export default PromptDock;
